import LandingPageNavArea from "./LandingPageNavArea";

export default LandingPageNavArea;
